import { useMutation } from "react-query";
import getOrgDraft from "../services/getOrgDraft";

function useGetOrgDraft() {
    return useMutation(["get-org-draft"], getOrgDraft);
}

export default useGetOrgDraft;